/**
 * App version – increment when releasing updates
 * Displayed on the /version page
 */
export const APP_VERSION = '1.0.1';
